/// <reference path="../../ui/types.d.ts" />
import { FC, useEffect } from 'react';

interface OAuthPageProps {
    message: string;
    oauthMode?: string;
}

export const OAuthPage: FC<OAuthPageProps> = ({ message, oauthMode }) => {
    useEffect(() => {
        if (oauthMode !== 'polling') {
            window.opener.postMessage(message, window.location.origin);
        }
        window.close();
    });

    return <></>;
};
